import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTriangleLeftMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconChevronTriangleLeftMedium"><Path d="M15 6.74978C14.9999 6.4583 14.8306 6.19321 14.5664 6.07009C14.3022 5.94715 13.9907 5.98818 13.7676 6.17556L7.51758 11.4256C7.34801 11.568 7.25005 11.7783 7.25 11.9998C7.25 12.2213 7.34801 12.4315 7.51758 12.574L13.7676 17.824C13.9907 18.0115 14.3022 18.0525 14.5664 17.9295C14.8306 17.8063 15 17.5413 15 17.2498V6.74978Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTriangleLeftMedium;
